module.exports = ({ html }) => html;
